module.exports = __webpack_public_path__ + "img/wheel-track.a8b91ec6.svg";